module.exports = __webpack_public_path__ + "img/name.ba909892.svg";